const INTAKE_FORM_DATE_PATTERN = /^(\d{2})-(\d{2})-(\d{4})$/;

function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
}

export function parseIntakeFormDate(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (value instanceof Date) {
    if (!isValidDate(value)) {
      return null;
    }

    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value !== "string") {
    return null;
  }

  const match = value.trim().match(INTAKE_FORM_DATE_PATTERN);
  if (!match) {
    return null;
  }

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

export function formatIntakeFormDate(value) {
  const date = parseIntakeFormDate(value);
  if (!date) {
    return null;
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());

  return `${day}-${month}-${year}`;
}

export function getShiftedEndDate(startDate, previousStartDate, endDate) {
  const start = parseIntakeFormDate(startDate);
  const previousStart = parseIntakeFormDate(previousStartDate);
  const end = parseIntakeFormDate(endDate);

  if (!start || !previousStart || !end || end < previousStart) {
    return null;
  }

  const shiftedEnd = new Date(start);
  shiftedEnd.setDate(
    shiftedEnd.getDate() +
      Math.round((end.getTime() - previousStart.getTime()) / 86400000),
  );

  return formatIntakeFormDate(shiftedEnd);
}
